import { LayoutOptions } from "../helpers/prop-types-helper";

enum textAlignment {
  left = "left",
  center = "center",
}

export const TextAlignment = {
  textAlignment: LayoutOptions.Options(textAlignment),
};
